import { FormControlLabel, Switch as MUISwitch } from '@mui/material'

export const Switch = ({
  name,
  label,
  onChange,
  checked,
  disabled,
}: {
  name: string
  label?: string
  onChange?: (e: any) => void
  checked?: boolean
  disabled?: boolean
}) => {
  return (
    <FormControlLabel
      control={
        <MUISwitch checked={checked} onChange={onChange} disabled={disabled} />
      }
      label={label}
    />
  )
}
